import cn from 'classnames'
import { ErrorMessage, useFormikContext } from 'formik'
import { useState, type FC, type RefObject } from 'react'
import {
  type Values
} from '../../SignUpForm.interface'
import FieldLabel from '../FieldLabel/FieldLabel'
import styles from './FormFileInput.module.scss'

interface FileProps {
  className?: string;
  name: keyof Values;
  label: string;
  optionalText?: string;
  imageRef?: RefObject<HTMLInputElement>;
}

const FormikFileInput: FC<FileProps> = ({
  className,
  name,
  label,
  optionalText,
  imageRef
}) => {
  const { errors, touched, setFieldValue } = useFormikContext<Values>()
  const hasError = errors[name] !== null && touched[name]

  const [fakeValue, setFakeValue] = useState('')

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (!e?.target?.files?.[0]) return

    setFieldValue(name, e.target.files[0].name)
      .then(() => {
        setFakeValue(e?.target?.files?.[0]?.name ?? '')
      })
      .catch(console.error)
  }

  const handleClick = (): void => {
    imageRef?.current?.click()
  }

  return (
    <div className="form-field">
      <label htmlFor={name}>
        {label && <FieldLabel label={label} optional={optionalText} />}
        <input
          type="file"
          // ref={imageRef}
          name={`fake_${name}`}
          id={name}
          ref={imageRef}
          style={{ display: 'none' }}
          accept="image/png, image/jpeg"
          className={cn(
            styles['form-input__input'],
            {
              [styles['form-input__input-error']]:
                (hasError ?? false) && errors[name]
            },
            className != null ? styles[className] : ''
          )}
          aria-invalid={hasError}
          // eslint-disable-next-line react/jsx-props-no-spreading
          onChange={handleFileChange}
        />
        <div
          className={cn(
            styles['form-input__input'],
            {
              [styles['form-input__input-error']]:
                (hasError ?? false) && errors[name]
            },
            className != null ? styles[className] : '',
            styles['form-input__fake-input']
          )}
        >
          <span>{fakeValue}</span>
          <button
            onClick={handleClick}
            type="button"
            className={styles['form-input__select-file']}
          >
            Browse
          </button>
        </div>
      </label>
      <ErrorMessage
        className={styles['form-input__error-message']}
        component="div"
        name={name}
      />
    </div>
  )
}

export default FormikFileInput
